// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "e2295643e4c05ece62b467c161779d5aacb7291f/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};